import React, { useContext } from 'react';
import styled from 'styled-components';

import CharacterCount from 'components/text_editor/character_count';
import Composer, { Header, HeaderText, useComposer } from './shared/composer';
import { EmojiStyles, Separator } from './shared/editor_styles';
import ComposerContext from './contexts/composer_context';
import ConversationMessageAddressField from 'components/composer/conversation_message_address_field';
import { EditorContainer, useEditor } from './shared/editor';
import { MessageChannelType } from 'models/conversation_message.js';
import MessagingEditor from './editors/messaging';
import PlainTextSerializer from 'components/text_editor/serializers/plaintext_serializer';
import SendComposerConversationMessage from 'actions/composer/send_composer_conversation_message';

// SMS character limit is 1600.
// Chat character limit is 2048.
// Twitter DM character limit is 10000.
// WhatsApp character limit is 65,536.
// For now, use smaller generic max message size of 2048 to align with Chat and prevent issues rendering large messages.
const MAX_CONVERSATION_MESSAGE_SIZE = 2048;

export function ConversationMessageComposer() {
  const composer = useComposer(SendComposerConversationMessage);
  const editorProps = useEditor('bodyHtml', composer);
  const [composerProps] = composer;
  const { composition } = useContext(ComposerContext);
  const customerAddress = composition.content.customerAddress;
  const customerDisplayName = composition.content.customerDisplayName;
  const companyAddress = composition.content.companyAddress;
  const companyDisplayName = composition.content.companyDisplayName;
  const channel = composition.content.channel;
  const channelDisplayTitle = composition.content.channelDisplayTitle;

  return (
    <Composer submitText="Send" {...composerProps} disableSubmit={isOverCharacterLimit()}>
      <Header>
        <Left>
          <HeaderText color="green400">{channelDisplayTitle || channel}</HeaderText>
          <div className="conversationMessageComposer-address-label">To</div>
          <ConversationMessageAddressField address={customerDisplayName || customerAddress} />
        </Left>
        <Right>
          <React.Fragment>
            <EmojiStyles {...editorProps} />
            <Separator />
          </React.Fragment>
          <div className="conversationMessageComposer-address-label">From</div>
          <div className="conversationMessageComposer-from-container">
            <ConversationMessageAddressField address={companyDisplayName || companyAddress} />
          </div>
        </Right>
      </Header>
      <EditorContainer>
        <MessagingEditor placeholder="Type to reply" {...editorProps} />
        {renderCharacterCount()}
      </EditorContainer>
    </Composer>
  );

  function isOverCharacterLimit() {
    let characterCount = (editorProps.value ? PlainTextSerializer.serialize(editorProps.value) : '').length;
    switch (channel) {
      case MessageChannelType.TWITTER:
      case MessageChannelType.WHATSAPP:
        return characterCount > MAX_CONVERSATION_MESSAGE_SIZE;
    }
    return false;
  }

  function renderCharacterCount() {
    if (!isOverCharacterLimit(editorProps.value, channel)) {
      return null;
    }
    return <CharacterCount {...editorProps} maxCharacters={MAX_CONVERSATION_MESSAGE_SIZE} />;
  }
}

export default React.memo(ConversationMessageComposer);

const Left = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
`;
const Right = styled.div`
  align-items: center;
  display: flex;
`;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/composer/conversation_message_composer.jsx